import { Injectable } from '@angular/core';
import { WebSocketService } from '../web-socket.service';
import { CalendarEvent, Place } from 'src/app/interfaces/interfaces';
import { BehaviorSubject, Observable, switchMap, timer } from 'rxjs';
import * as moment from 'moment';
// import { AvailablePlacesStore } from 'src/app/shared/available-places/available-places.store';

@Injectable({
  providedIn: 'root',
})
export class PlacesService {
  // public places$ = new BehaviorSubject<Place[]>([]);
  // public unfilteredPlaces$ = new BehaviorSubject<Place[]>([]);
  // public fetchAvaialbeIsFinished:boolean= true;
  // public fetchFavoriteIsFinished:boolean= true;
  // public fetchMyBookingsIsFinished:boolean= true;
  // public favoritePlaces$ = new BehaviorSubject<Place[]>([]);
  // public lastupdatePlaces = moment();
  // public lastupdateFavorite = moment();
  // public lastupdateMyBooking ;
  // public MyBooking$ = new BehaviorSubject<CalendarEvent[]>([]);
  // public favoriteListUPN : string[];
  // public subscribeForAvailabePlaces$;
  // public subscribeForMyBooking$;


  constructor(private webSocketService: WebSocketService) { }


 




  // public syncMyBookingData(events: CalendarEvent[]) {
  //   const myBookingEvents = this.MyBooking$.getValue();
  //   events.forEach(event => {
  //     if(this.checkIfIsNewEventOrNewStatus(event,myBookingEvents)){
  //       event.isNewEvent=true;
  //     }
  //   }
  //   );

  //   const mergedEvents = [...events, ...myBookingEvents];
  //   // Remove duplicates from the merged array
  //   const uniqueMergedEvents = mergedEvents.filter((event, index, self) =>
  //     index === self.findIndex(e => e.id === event.id)
  //   );
  //   // Update the BehaviorSubject with the final result
  //   this.MyBooking$.next(uniqueMergedEvents);
  // }
  // public checkIfIsNewEventOrNewStatus(event, myBookingEvents) {
  //   var currentBooking = myBookingEvents.filter(bookingEvent => bookingEvent.id === event.id);
  //   if (event.resourceStatus == "TentativelyAccepted" && currentBooking.resourceStatus == "Pending") {
  //     return false;
  //   }
  //   return(!myBookingEvents.some(bookingEvent => bookingEvent.id === event.id))
  //   || (myBookingEvents.some(bookingEvent => bookingEvent.id === event.id && bookingEvent.resourceStatus != event.resourceStatus))
  // }
  
  // public resetIsNewEventValue(){
  //   const myBookingEvents = this.MyBooking$.getValue();
  //   myBookingEvents.forEach(element => {
  //     element.isNewEvent = false;
  //   });
  // }
  
  // public deleteEventFromMyBooking(EventId:string) {
  //   let currnteMyBooking=this.MyBooking$.value;
  //   currnteMyBooking = currnteMyBooking.filter((event) => event.id != EventId);;
  //   this.MyBooking$.next(currnteMyBooking);
  //   localStorage.setItem("myBookings", JSON.stringify(currnteMyBooking))
  // }

  // public deleteSeriesEventFromMyBooking(seriesMasterId:string) {
  //   let currnteMyBooking=this.MyBooking$.value;
  //   currnteMyBooking = currnteMyBooking.filter((event) => event.seriesMasterId != seriesMasterId);
  //   this.MyBooking$.next(currnteMyBooking);
  //   localStorage.setItem("myBookings", JSON.stringify(currnteMyBooking))
  // }

  // public NeedToRefreshDataForFavorite(isFavorite) : boolean {
  //   let lastupdateInSecondsForFavorite = moment.duration(moment().diff(this.lastupdateFavorite)).asSeconds();
  //   console.log("favorite:",lastupdateInSecondsForFavorite)
  //   return isFavorite && (lastupdateInSecondsForFavorite >= 30 || !this.fetchFavoriteIsFinished || this.favoritePlaces$.value.length == 0)
  // }
  
  // public NeedToRefreshDataForAvailabe(isFavorite) : boolean {
  //   let lastupdateInSecondsForAvailable = moment.duration(moment().diff(this.lastupdatePlaces)).asSeconds();
  //   console.log("available:",(!isFavorite && lastupdateInSecondsForAvailable >= 30), (!isFavorite && !this.fetchAvaialbeIsFinished) , (!isFavorite && this.places$.value.length == 0),lastupdateInSecondsForAvailable);
  //   return !isFavorite && (lastupdateInSecondsForAvailable >= 30 || !this.fetchAvaialbeIsFinished || this.places$.value.length == 0)
  // }

  // public NeedToRefreshDataForMyBooking(): boolean {
  //   let hasOldEvents = this.removeOldMeetingsAndCheck();
  //   if(this.lastupdateMyBooking==undefined){
  //     return true
  //   }
  //   let lastupdateInSecondsForMyBooking = moment.duration(moment().diff(this.lastupdateMyBooking)).asSeconds();
  //   console.log("mybooking:", lastupdateInSecondsForMyBooking >= 60, !this.fetchMyBookingsIsFinished, this.MyBooking$.value.length == 0, lastupdateInSecondsForMyBooking);
  //   return lastupdateInSecondsForMyBooking >= 60 || !this.fetchMyBookingsIsFinished || this.MyBooking$.value.length == 0 || hasOldEvents;
  // }
  // public removeOldMeetingsAndCheck(): boolean {
  //   const hasOldEvents = this.MyBooking$.value.some(event =>
  //     moment(event.endTime).isBefore(moment())
  //   );
  
  //   if (hasOldEvents) {
  //     this.MyBooking$.next(
  //       this.MyBooking$.value.filter(event => !moment(event.endTime).isBefore(moment()))
  //     );
  //   }
  
  //   return hasOldEvents;
  // }

  // public PrepareFavoriteVariable() {
  //   this.fetchFavoriteIsFinished= false;
  //   this.favoritePlaces$.next([]);
  // }

  // public PrepareAvailabeVariable() {
  //   this.fetchAvaialbeIsFinished= false;
  //   this.places$.next([]);
  // }

  // public PrepareMyBookingsVariable() {
  //   this.fetchMyBookingsIsFinished= false;
  // }
}
